import React from "react";
import { Col } from "antd";

function Logo() {
  return (
   
      <img
        src={process.env.PUBLIC_URL + "/static/images/logo.png"}
        alt="Logo"
      /> 
  );
}

export default Logo;
